export default __webpack_public_path__ + "static/magnesium-2c8b0c4fc7c90152f503d3ad2bebeed9.jpg";